module.exports = __webpack_public_path__ + "img/fotos_1.f7994dd9.jpg";